/**
 * @module コールバック処理
 */
/* nativeCallback.js */
/* 目的: Native部からのコールバックを受け付ける関数群を定義
  実際の処理は各ページで行う
  本ファイルではすべての定nativeCallbackをリストアップするために作成
*/

/********************
	関数宣言
********************/
/**
 * 返り値の文字列をチェック
 * @description 「errorCode === "FE-NA09-C0000" || errorCode === "FE-NI09-C0000")」の記述を回避するために使用
 * @return {boolean} true: 特定のコードを含む  true: 特定のコードを含まない
 */
function codeInclude(callbackResult, checkCode) {
  return callbackResult.indexOf(checkCode) === -1 ? false : true;
}
/**
 * OSをチェック（Android）
 * @return {boolean} true: 特定の文言を含む  true: 特定の文言を含まない
 */
function codeIsAndroid(errorCode) {
  return errorCode.indexOf('FE-NA') === -1 ? false : true;
}
/**
 * OSをチェック（Ios）
 * @return {boolean} true: 特定の文言を含む  true: 特定の文言を含まない
 */
function codeIsIos(errorCode) {
  return errorCode.indexOf('FE-NA') === -1 ? false : true;
}

/**
 * IF01_アカウント情報記録要求
 * @return {object}
 */
function onRegisterAccountInfoFinished(errorCode) {
  // consolelog('onRegisterAccountInfoFinished[' + Array.prototype.slice.call(arguments).join(',') + ']'); // eslint-disable-line
  return { errorCode: errorCode };
}
/**
 * IF02_ログイン設定記録要求
 * @return {object}
 */
function onRegisterLoginSettingFinished(errorCode) {
  // consolelog('onRegisterLoginSettingFinished[' + Array.prototype.slice.call(arguments).join(',') + ']'); // eslint-disable-line
  return { errorCode: errorCode };
}
/**
 * IF03_設定アプリ表示要求
 * @return {object}
 */
function onOpenSettingAppFinished(errorCode) {
  // consolelog('onOpenSettingAppFinished[' + Array.prototype.slice.call(arguments).join(',') + ']'); // eslint-disable-line
  return { errorCode: errorCode };
}
/**
 * IF04_アプリNative部保持情報要求
 * @param {string} errorCode
 * @param {string} nativeVersion
 * @param {string} loginMethod
 * @param {string} deviceToken
 * @param {string} isPushNotificationAvailable
 * @param {string} isBiometricAuthAvailable
 * @param {string} isPasscodeAuthAvailable
 * @return {object}
 */
function onResponseNativeAppInfo(
  errorCode,
  nativeVersion,
  loginMethod,
  deviceToken,
  isPushNotificationAvailable,
  isBiometricAuthAvailable,
  isPasscodeAuthAvailable
) {
  var ret = {};

  ret.errorCode = errorCode;
  ret.nativeVersion = decodeURIComponent(nativeVersion); // 各コンポーネントで呼び出す前にデコード
  ret.loginMethod = loginMethod; // 0: ID/PW毎回入力, 1: ID省略, 2:パスコード/生体認証
  ret.deviceToken = decodeURIComponent(deviceToken); // 各コンポーネントで呼び出す前にデコード
  ret.isPushNotificationAvailable = isPushNotificationAvailable; // "0": 利用可否未定義, "1": 利用許可, "-1": 利用不許可
  ret.isBiometricAuthAvailable = isBiometricAuthAvailable; // "0": 未対応端末, "1": 利用可能, "-1": 数回間違えたのでNativeでロック中, "-2": 未登録
  ret.isPasscodeAuthAvailable = isPasscodeAuthAvailable; // "0": 未登録, "1": 利用可能, "-1": 数回間違えたのでNativeでロック中

  return ret;
}
/**
 * IF_05アカウント情報要求
 * @param {string} errorCode
 * @param {string} userId
 * @param {string} password
 * @param {string} terminalInfo
 * @return {object}
 */
function onResponseAccountInfo(errorCode, userId, password, terminalInfo) {
  var ret = {};

  ret.errorCode = errorCode;
  ret.userId = decodeURIComponent(userId); // 各コンポーネントで呼び出す前にデコード
  ret.password = decodeURIComponent(password); // 各コンポーネントで呼び出す前にデコード
  ret.terminalInfo = decodeURIComponent(terminalInfo); // 各コンポーネントで呼び出す前にデコード

  return ret;
}
/**
 * IF06_生体認証要求
 * @param {string} errorCode
 * @return {object}
 */
function onResponseBiometricAuth(errorCode) {
  // eslint-disable-line
  // consolelog('onResponseBiometricAuth[' + Array.prototype.slice.call(arguments).join(',') + ']'); // eslint-disable-line
  return { errorCode: errorCode };
}
/**
 * IF07_パスコード認証要求
 * @param {string} errorCode
 * @return {object}
 */
function onResponsePasscodeAuth(errorCode) {
  // consolelog('onResponsePasscodeAuth[' + Array.prototype.slice.call(arguments).join(',') + ']'); // eslint-disable-line
  return { errorCode: errorCode };
}
/**
 * IF08_スプラッシュ画面Close要求
 * @param {string} errorCode
 * @return {object}
 */
function onCloseSplashFinished(errorCode) {
  // consolelog('onCloseSplashFinished[' + Array.prototype.slice.call(arguments).join(',') + ']'); // eslint-disable-line
  return { errorCode: errorCode };
}
/**
 * IF09_言語設定記録要求
 * @param {string} errorCode
 * @return {object}
 */
function onRegisterLanguageSettingFinished(errorCode) {
  // consolelog('onRegisterLanguageSettingFinished[' + Array.prototype.slice.call(arguments).join(',') + ']'); // eslint-disable-line
  return { errorCode: errorCode };
}
/**
 * IF10_アプリNative部エラー通知
 * @param {string} errorCode
 * @return {object}
 */
function onNativeError(errorCode) {
  // consolelog('onNativeError[' + Array.prototype.slice.call(arguments).join(',') + ']'); // eslint-disable-line
  return { errorCode: errorCode };
}
/**
 * IF11_ライフサイクルイベント通知
 * @param {string} errorCode
 * @param {string} appState
 * @return {object}
 */
function onAppLifeCycleStateChanged(errorCode, appState) {
  // consolelog('onAppLifeCycleStateChanged[' + Array.prototype.slice.call(arguments).join(',') + ']'); // eslint-disable-line
  return { errorCode: errorCode, appState: appState };
}
/**
 * IF12_外部アプリケーション起動通知
 * @param {string} errorCode
 * @return {object}
 */
function onOpenExternalAppFinished(errorCode) {
  // consolelog('onOpenExternalAppFinished[' + Array.prototype.slice.call(arguments).join(',') + ']'); // eslint-disable-line
  return { errorCode: errorCode };
}
/**
 * IF13_デバイストークン更新通知
 * @param {string} errorCode
 * @return {object}
 */
function onDeviceTokenUpdated(errorCode) {
  return { errorCode: errorCode };
}

export default {
  codeInclude,
  codeIsAndroid,
  codeIsIos,
  onRegisterAccountInfoFinished,
  onRegisterLoginSettingFinished,
  onOpenSettingAppFinished,
  onResponseNativeAppInfo,
  onResponseAccountInfo,
  onResponseBiometricAuth,
  onResponsePasscodeAuth,
  onCloseSplashFinished,
  onRegisterLanguageSettingFinished,
  onNativeError,
  onAppLifeCycleStateChanged,
  onOpenExternalAppFinished,
  onDeviceTokenUpdated,
};
